import * as tslib_1 from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Target } from 'react-popper';
import "./PopoverTarget.css";

var PopoverTarget = function PopoverTarget(props) {
  var children = props.children,
      className = props.className,
      other = tslib_1.__rest(props, ["children", "className"]);

  var finalClassName = cx('nx-popover-target', className);
  return React.createElement(Target, tslib_1.__assign({
    className: finalClassName
  }, other), children);
};

PopoverTarget.propTypes = {
  className: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
};
export default PopoverTarget;

try {
  // @ts-ignore
  PopoverTarget.__docgenInfo = {
    "description": "",
    "displayName": "PopoverTarget",
    "props": {
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "component": {
        "defaultValue": null,
        "description": "",
        "name": "component",
        "required": false,
        "type": {
          "name": "string | ComponentClass<any, any> | StatelessComponent<any> | undefined"
        }
      },
      "innerRef": {
        "defaultValue": null,
        "description": "",
        "name": "innerRef",
        "required": false,
        "type": {
          "name": "((ref: HTMLElement) => void) | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}